import { ActionContract, ActionRegistry } from "../../../ServiceDesk/sdServices/agent-action/registry-contract";
import { ActionImplementation } from "../../../ServiceDesk/sdServices/agent-action/implementation-contract";
import { SdServicesSharedEnums } from "../../../ServiceDesk/sdServices/sdServices-shared-enums";

export const actionTriggerName = "MultiActionTestAction";
export const actionTriggerNameUnknownEligibility = "MultiActionTestAction1";
export const actionTriggerNameHover = "MultiActionTestHover";
export interface TestActionContext {
  subscriptionId: string;
}

export class MultiActionHarnessController {
  public restrictedUXTypes: any[];

  public actionContext: TestActionContext = {
    subscriptionId: "ec02ad7a-09b9-4072-82d5-702435291c2c"
  };
  // @ngInject
  constructor(private sdServicesSharedEnums: SdServicesSharedEnums) {
    this.restrictedUXTypes = [this.sdServicesSharedEnums.actionUXType.Routed];
  }

  public getActionContext = () => {
    return this.actionContext;
  };

  public pivots = [
    {
      name: "Thing1Thing1Thing1Thing1",
      uniqueId: "Thing1",
      biId: "Pivot Harness 1",
      isCloseable: true
    },
    {
      name: "Thing2Thing2Thing2",
      uniqueId: "Thing2"
    },
    {
      name: "Thing3Thing3",
      uniqueId: "Thing3",
      isCloseable: true
    },
    {
      name: "Thing4",
      uniqueId: "Thing4"
    },
    {
      name: "Thing5Thing5Thing5Thing5Thing5Thing5Thing5",
      uniqueId: "Thing5",
      isCloseable: true
    }
  ];

  public rowData: any[] = [
    {
      comm: {
        test: "2"
      },
      caseId: "1335846225",
      state: "Open",
      status: "Resolving the issue",
      channel: "Phone",
      language: "EN-US",
      product: "Xbox",
      category: "Accounts & Billing",
      issue: "Power Supply replacement Fulfillment",
      created: "Apr 19, 2016 7:07 AM 12 hrs ago",
      lastUpdated: "Apr 19, 2016 7:07 AM 5 mins ago",
      lastClosed: "N/A",
      modifiedBy: "Kyle Geddes",
      owner: "Vivek Manju",
      notShown: "Chase Was Here!"
    },
    {
      comm: {
        test: "1"
      },
      caseId: "1653546513",
      state: "Open",
      status: "Resolving the issue",
      channel: "Phone",
      language: "EN-US",
      product: "Xbox",
      category: "Accounts & Billing",
      issue: "Overheating",
      created: "Apr 19, 2016 7:07 AM 12 hrs ago",
      lastUpdated: "Apr 19, 2016 7:07 AM 5 mins ago",
      lastClosed: "N/A",
      modifiedBy: "Kyle Geddes",
      owner: "Vivek Manju",
      notShown: "Bleh!"
    },
    {
      comm: {
        test: "1"
      },
      caseId: "1653546513",
      state: "Open",
      status: "Resolving the issue",
      channel: "Phone",
      language: "EN-US",
      product: "Xbox",
      category: "Accounts & Billing",
      issue: "Overheating",
      created: "Apr 19, 2016 7:07 AM 12 hrs ago",
      lastUpdated: "Apr 19, 2016 7:07 AM 5 mins ago",
      lastClosed: "N/A",
      modifiedBy: "Kyle Geddes",
      owner: "Vivek Manju",
      notShown: "Bleh!"
    },
    {
      comm: {
        test: "1"
      },
      caseId: "1653546513",
      state: "Open",
      status: "Resolving the issue",
      channel: "Phone",
      language: "EN-US",
      product: "Xbox",
      category: "Accounts & Billing",
      issue: "Overheating",
      created: "Apr 19, 2016 7:07 AM 12 hrs ago",
      lastUpdated: "Apr 19, 2016 7:07 AM 5 mins ago",
      lastClosed: "N/A",
      modifiedBy: "Kyle Geddes",
      owner: "Vivek Manju",
      notShown: "Bleh!"
    }
  ];
}
// @ngInject
export function MultiActionHarness(
  actionRegistryService: ActionRegistry,
  sdServicesSharedEnums: SdServicesSharedEnums
): void {
  let eligibilities = new Map<string, any>();

  let setEligibility = () => {
    eligibilities.set("_MULTI_ACTION_HARNESS_BUY_PRODUCT_", this.sdServicesSharedEnums.actionEligibility.Default);
    eligibilities.set(
      "_MULTI_ACTION_HARNESS_RENT_PRODUCT_",
      this.sdServicesSharedEnums.actionEligibility.NotApplicable
    );
    eligibilities.set("_MULTI_ACTION_HARNESS_SELL_PRODUCT_", this.sdServicesSharedEnums.actionEligibility.NotAllowed);
  };

  let createActionImplementation = (
    actionName: string,
    locKey: string,
    uxType: any,
    eligibility: any,
    contentAutomationId: string,
    actionAutomationId: string,
    hoverActionName?: string
  ) => {
    eligibilities.set(locKey, eligibility);

    let actionImpl: ActionImplementation<TestActionContext> = {
      getEligibility: (actionContext: TestActionContext) => {
        return eligibilities.get(locKey);
      },
      invoke: (actionContract: ActionContract<TestActionContext>) => {
        if (uxType === this.sdServicesSharedEnums.actionUXType.None) {
          window.setTimeout(() => {
            actionContract.actionDeferral.resolve();
          }, 1000);
          return undefined;
        }

        return {
          content: `<button data-automation-id="${contentAutomationId}" class="multi-action-e2e-test" ng-click="actionDeferral.resolve()">Finish ${actionName} with displayName as {{::${locKey}|loc:'ShellCommon'}} and subscriptionId as ${actionContract.actionContext.subscriptionId}</button>`
        };
      },
      hoverActionName,
      uxTypes: [uxType],
      triggeredBy: actionName,
      displayName: {
        locAppId: "ShellCommon",
        locKey: locKey
      },
      automationId: actionAutomationId
    };

    return actionImpl;
  };

  let actionImplementations: ActionImplementation<TestActionContext>[] = [];

  actionImplementations.push(
    createActionImplementation(
      actionTriggerName,
      "_MULTI_ACTION_HARNESS_ADD_SUB_",
      sdServicesSharedEnums.actionUXType.None,
      sdServicesSharedEnums.actionEligibility.Default,
      "add-sub",
      undefined
    )
  );
  actionImplementations.push(
    createActionImplementation(
      actionTriggerName,
      "_MULTI_ACTION_HARNESS_CANCEL_SUB_",
      sdServicesSharedEnums.actionUXType.Modal,
      sdServicesSharedEnums.actionEligibility.NotAllowed,
      "cancel-sub",
      undefined
    )
  );
  actionImplementations.push(
    createActionImplementation(
      actionTriggerName,
      "_MULTI_ACTION_HARNESS_RENEW_SUB_",
      sdServicesSharedEnums.actionUXType.Routed,
      sdServicesSharedEnums.actionEligibility.NotApplicable,
      "renew-sub",
      undefined
    )
  );
  actionImplementations.push(
    createActionImplementation(
      actionTriggerName,
      "_MULTI_ACTION_HARNESS_UPDATE_SUB_",
      sdServicesSharedEnums.actionUXType.Routed,
      sdServicesSharedEnums.actionEligibility.Default,
      "update-sub",
      undefined
    )
  );
  actionImplementations.push(
    createActionImplementation(
      actionTriggerName,
      "_MULTI_ACTION_HARNESS_ADD_PI_",
      sdServicesSharedEnums.actionUXType.Modal,
      sdServicesSharedEnums.actionEligibility.NotAllowed,
      "add-pi",
      "add-pi-action"
    )
  );
  actionImplementations.push(
    createActionImplementation(
      actionTriggerName,
      "_MULTI_ACTION_HARNESS_REMOVE_PI_",
      sdServicesSharedEnums.actionUXType.Modal,
      sdServicesSharedEnums.actionEligibility.NotApplicable,
      "remove-pi",
      undefined
    )
  );
  actionImplementations.push(
    createActionImplementation(
      actionTriggerName,
      "_MULTI_ACTION_HARNESS_OTHER_",
      sdServicesSharedEnums.actionUXType.None,
      sdServicesSharedEnums.actionEligibility.Default,
      "other",
      undefined,
      actionTriggerNameHover
    )
  );

  // actions for third example. (mostly around eligibility not known till certain point.)
  actionImplementations.push(
    createActionImplementation(
      actionTriggerNameUnknownEligibility,
      "_MULTI_ACTION_HARNESS_BUY_PRODUCT_",
      sdServicesSharedEnums.actionUXType.Modal,
      undefined,
      "buy-product",
      undefined
    )
  );
  actionImplementations.push(
    createActionImplementation(
      actionTriggerNameUnknownEligibility,
      "_MULTI_ACTION_HARNESS_RENT_PRODUCT_",
      sdServicesSharedEnums.actionUXType.Modal,
      sdServicesSharedEnums.actionEligibility.NotYetKnown,
      "rent-product",
      undefined
    )
  );
  actionImplementations.push(
    createActionImplementation(
      actionTriggerNameUnknownEligibility,
      "_MULTI_ACTION_HARNESS_SELL_PRODUCT_",
      sdServicesSharedEnums.actionUXType.Modal,
      undefined,
      "sell-product",
      undefined
    )
  );

  actionImplementations.push(
    createActionImplementation(
      actionTriggerNameHover,
      "_MULTI_ACTION_HOVER_OPTION_1_",
      sdServicesSharedEnums.actionUXType.None,
      sdServicesSharedEnums.actionEligibility.Default,
      "hover1",
      undefined
    )
  );
  actionImplementations.push(
    createActionImplementation(
      actionTriggerNameHover,
      "_MULTI_ACTION_HOVER_OPTION_2_",
      sdServicesSharedEnums.actionUXType.None,
      sdServicesSharedEnums.actionEligibility.NotAllowed,
      "hover2",
      undefined
    )
  );
  actionImplementations.push(
    createActionImplementation(
      actionTriggerNameHover,
      "_MULTI_ACTION_HOVER_OPTION_3_",
      sdServicesSharedEnums.actionUXType.None,
      sdServicesSharedEnums.actionEligibility.Default,
      "hover3",
      undefined
    )
  );

  actionImplementations.forEach((actionImplementation: ActionImplementation<TestActionContext>) => {
    actionRegistryService.registerAction(actionImplementation);
  });
}
